document.addEventListener("DOMContentLoaded", function () {
  const cookie_button = document.querySelector(".showcookie-layer");

  cookie_button.addEventListener("click", function (e) {
    e.preventDefault();
    cookiebar.show(true);
  });
});
